import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import JourneySearchDate from './JourneySearchDate';

export default injectIntl(withRouter(JourneySearchDate));
